import { getLocalizedString } from "../../../../../../../../../../utils/utils/get-localized-string.js";
function getLineItemCartDiscountDescription(lineItemRaw, locale) {
  const { discounts } = lineItemRaw;
  if (!discounts || discounts.length === 0) {
    return;
  }
  const cartDiscounts = discounts?.filter((discount) => discount.type === "CartDiscount");
  if (!cartDiscounts.length || !cartDiscounts[0]) {
    return;
  }
  return getLocalizedString(locale, cartDiscounts[0].description);
}
export {
  getLineItemCartDiscountDescription
};
//# sourceMappingURL=get-line-item-cart-discount-description.js.map
